// A5 (Botlar) — bot moderatsiya amallari uchun modul-lokal ma'lumot qatlami.
// `lib/adapters.ts` / `i18n/*` ga TEGMAYDI (C-sessiya HOT) — devApi.ts naqshi.
//
// LIST manbai REAL: GET /admin/bots (adminH.Bots, `handlers/admin.go`) — botlar
// ro'yxati jonli. Cheklash = REAL: POST /admin/bots/:id (adminH.EditBot) `revoked`
// bayrog'i orqali. Rate-limit / VIP / hard-delete backend'lari LANE-A greenfield
// → mutatsiya deploy'gacha 404 (fail-soft: xatolik toast'i, ro'yxat buzilmaydi).
import { api } from '@/lib/api'
import type { FetchParams, FetchResult } from '@/components/DataTable/types'

/** GET /admin/bots satri (+ greenfield ixtiyoriy maydonlar deploy'dан keyin to'ladi). */
export interface BotModRow {
  id: number
  username?: string | null
  first_name?: string | null
  is_official: boolean
  created_at: number
  last_seen?: number | null
  /** A5.11 — cheklangan (bots.revoked). */
  revoked?: boolean
  /** A5.07 — individual rate-limit (greenfield). */
  rate_per_minute?: number | null
  rate_burst?: number | null
  /** A5.15 — VIP tarif (greenfield). */
  vip_tier?: string | null
  vip_multiplier?: number | null
}

function toResult<T>(rows: T[], params: FetchParams, search?: (r: T) => string): FetchResult<T> {
  const q = params.search.trim().toLowerCase()
  const filtered = q && search ? rows.filter((r) => search(r).toLowerCase().includes(q)) : rows
  const start = params.page * params.pageSize
  return { rows: filtered.slice(start, start + params.pageSize), total: filtered.length }
}

async function safeList<T>(path: string, key: string, signal: AbortSignal): Promise<T[]> {
  try {
    const data = await api.get<Record<string, T[]>>(path, { signal })
    return (data?.[key] as T[] | undefined) ?? []
  } catch {
    return []
  }
}

const label = (r: BotModRow) => `${r.username ?? ''} ${r.first_name ?? ''}`

/** REAL — GET /admin/bots (A5.01 bilan bir manba). */
export function fetchBotsForMod(params: FetchParams): Promise<FetchResult<BotModRow>> {
  return safeList<BotModRow>('/admin/bots', 'bots', params.signal).then((rows) =>
    toResult(rows, params, label),
  )
}

/** A5.11 — REAL. Cheklash/cheklovni olib tashlash = POST /admin/bots/:id {revoked}. */
export function restrictBot(id: number, restricted: boolean): Promise<{ ok: boolean }> {
  return api.post<{ ok: boolean }>(`/admin/bots/${id}`, { revoked: restricted })
}

/** A5.13 — hard-delete (greenfield: DELETE /admin/bots/:id — deploy'gacha 404). */
export function deleteBot(id: number): Promise<{ ok: boolean }> {
  return api.del<{ ok: boolean }>(`/admin/bots/${id}`)
}

/** A5.07 — individual rate-limit (greenfield: POST /admin/bots/:id/rate-limit). */
export function setBotRateLimit(
  id: number,
  body: { per_minute: number; burst: number },
): Promise<{ ok: boolean }> {
  return api.post<{ ok: boolean }>(`/admin/bots/${id}/rate-limit`, body)
}

/** A5.15 — VIP limit oshirish (greenfield: POST /admin/bots/:id/vip-limit). */
export function setBotVipLimit(
  id: number,
  body: { tier: string; multiplier: number },
): Promise<{ ok: boolean }> {
  return api.post<{ ok: boolean }>(`/admin/bots/${id}/vip-limit`, body)
}

/** Modul-lokal RU satrlar (i18n HOT → keyinchalik keyга ko'chiriladi). */
export const BOT_MOD_STR = {
  // umumiy
  bot: 'Бот',
  name: 'Название',
  official: 'Официальный',
  registered: 'Зарегистрирован',
  done: 'Готово',
  failed: 'Не удалось выполнить',
  cancel: 'Отмена',
  save: 'Сохранить',
  search: 'Поиск бота',
  status: 'Статус',
  active: 'Активен',
  restricted: 'Ограничен',
  // A5.07 rate-limit
  rateLimits: 'Индивидуальные лимиты запросов',
  perMinute: 'Запросов/мин',
  burst: 'Всплеск',
  setLimit: 'Настроить лимит',
  limitSaved: 'Лимит сохранён',
  rateLimitHint: 'Персональный лимит для бота (0 = стандартный тариф).',
  // A5.11 restrict
  restrictTitle: 'Ограничение ботов',
  restrict: 'Ограничить',
  unrestrict: 'Снять ограничение',
  restrictConfirmTitle: 'Ограничить бота?',
  restrictConfirmDesc: 'Бот не сможет отправлять сообщения и обрабатывать обновления, пока ограничение активно.',
  unrestrictConfirmTitle: 'Снять ограничение?',
  unrestrictConfirmDesc: 'Бот снова сможет работать в обычном режиме.',
  restrictDone: 'Ограничение обновлено',
  // A5.13 delete
  deleteTitle: 'Удаление ботов',
  deleteBot: 'Удалить бота',
  officialCantDelete: 'Официального бота нельзя удалить',
  deleteConfirmTitle: 'Удалить бота безвозвратно?',
  deleteConfirmDesc: 'Токен отзывается, вебхуки и мини-приложения отключаются. Действие необратимо.',
  deleted: 'Бот удалён',
  // A5.15 VIP
  vipTitle: 'Повышение лимита бота (VIP)',
  vipTier: 'VIP-тариф',
  vipMultiplier: 'Множитель лимита',
  setVip: 'Назначить VIP',
  vipSaved: 'VIP-лимит назначен',
  vipHint: 'VIP-тариф повышает базовые лимиты запросов и очередей обновлений.',
  tierStandard: 'Стандарт',
  tierSilver: 'Silver (×2)',
  tierGold: 'Gold (×5)',
  tierPlatinum: 'Platinum (×10)',
  empty: 'Ботов пока нет',
} as const
